import DataTable from "react-data-table-component";
import { useState } from "react";
import api from "../services/api";
import { useEffect } from "react";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

function changeConfig(config, state = false) { // Forma temporal, mejorar a futuro, con un archivo de configuracion y una alerta en la aplicacion, no con el navegador. y que se guarden (Por ej, en cookies)
  if (config === "confirmAlertSubmit") {
    alert("Cambiada con exito")
    return (state === false);
  }
  else if (config === "dense") {
    alert("Cambiada con exito")
    return (!state)
  }
}

/************************************************************************************************************/
export default function Casos() {

  const [personas, setPersonas] = useState([]);
  const [searchTerm, setSearch] = useState("");
  const [estados, setEstados] = useState([]);

  const [confirmAlertSubmit, setConfirmAlertSubmit] = useState(true);
  const [rowDense, setRowDense] = useState(true);

  const leerPersonasAlta = async () => {
    const response = await api.get(`/leerCasos`);
    setPersonas(response.data);
    console.log("leidas")
  };

  const updateEstadoPersona = async (IdEstado, IdPersona) => {
    try {
      await api.patch(`/casos`, {
        IdEstado, IdPersona
      });
      leerPersonasAlta();
    } catch (error) {
      console.error(error);
    }
  };

  const createEstadoPersona = async (IdEstado, IdPersona) => {
    try {
      await api.post(`/estadosporpersona`, {
        IdPersona, IdEstado
      });
      leerPersonasAlta();
    } catch (error) {
      console.error(error);
    }
  };

  const verifyIfExist = async (Nombre, IdPersona) => {
    try {
      const responseByName = await api.get(`/getEstadoByName/${Nombre}`);
      const response = await api.get(`/verifyIfExist/${IdPersona}`);
      let IdEstado = responseByName.data[0].IdEstado;
      if (response.data[0].estadoExistente > 0) {
        updateEstadoPersona(IdEstado, IdPersona);
      }
      else {
        createEstadoPersona(IdEstado, IdPersona);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getEstadosAlta = async () => {
    const response = await api.get(`/estadosAlta`);
    setEstados(response.data);
  };

  useEffect(
    () => {
      leerPersonasAlta();
      getEstadosAlta();
    },
    []
  );

  const Alert = (idEstado, idPersona) => {
    confirmAlert({
      title: 'Confirmar cambio',
      message: '¿Esta seguro de realizar este cambio?.',
      buttons: [
        {
          label: 'Si',
          onClick: () => {
            verifyIfExist(idEstado, idPersona)
          }
        },
        {
          label: 'No',
        }
      ]
    });
  };


  const columnas = [
    // {
    //   name:"ID",
    //   selector: row => row.IdPersona,
    //   // sortable: true
    // },
    {
      name: 'Nombre',
      selector: row => row.Nombre,
      sortable: true
    },
    {
      name: 'Apellido',
      selector: row => row.Apellido,
      sortable: true
    },
    {
      name: 'NroDocumento',
      selector: row => row.NroDocumento,
      sortable: true
    },
    {
      name: 'Edad',
      selector: row => row.Edad,
      sortable: true
    },
    {
      name: 'Sexo',
      selector: row => row.Sexo,
      sortable: true
    },
    {
      name: 'Email',
      selector: row => row.Email,
      sortable: true,
    },
    // {
    //   name: 'Estado',
    //   selector: row => row.IdEstado,
    //   // sortable: true,
    //   cell: (row) => <ExpandedComponent rowData={row.IdPersona} estado={row.IdEstado} color={row.ColorAsociado} confirmAlertSubmitConfig={confirmAlertSubmit} />
    // },
    {
      name: 'Estado v2',
      sortable: true,
      selector: row => row.IdEstado,
      cell: (row) =>
        <form>
          <div className="control">
            <select
              value={row.estadoNombre}
              onChange={
                (e) => {
                  if (confirmAlertSubmit) {
                    Alert(e.target.value, row.IdPersona)
                  }
                  else {
                    verifyIfExist(e.target.value, row.IdPersona);
                  }
                }
              }
              required
              style={{ backgroundColor: row.ColorAsociado }}
            >
              {estados.map((estado) => (
                <option
                  key={estado.IdEstado}
                  value={estado.Nombre}
                  style={{ backgroundColor: estado.ColorAsociado }}
                >
                  {estado.Nombre}
                </option>
              ))}
            </select>
          </div>
        </form>
    }
  ]

  const searcher = (e) => {
    setSearch(e.target.value)
  }

  return (
    <div>
      <div className="columns mt-5 is-gapless">
        <div className="column is-centered" style={{ marginTop: "-10vh" }}>
          <label className="label">
          </label>
          <br />
          <div className="column container is-max-desktop is-half">
            <label className="label">
              Lista de casos
            </label>
            <input type="text" name="searchTerm" id="searchTerm" onChange={searcher} placeholder="Buscar" className="input" />
          </div>
          <button onClick={() => { setConfirmAlertSubmit(changeConfig("confirmAlertSubmit", confirmAlertSubmit)) }} className="button" style={{ backgroundColor: `${confirmAlertSubmit ? 'lightgreen' : '#FFCCCB'}` }}>Cambiar configuracion alerta</button>
          <button onClick={() => { setRowDense(changeConfig("dense", rowDense)) }} className="button" style={{ backgroundColor: `${rowDense ? 'lightgreen' : '#FFCCCB'}` }}>Cambiar separacion de filas</button>
          <DataTable
            dense={rowDense}
            responsive={false}
            columns={columnas}
            // onSort={handleSort}
            // key={sortState}
            data={(personas.filter((item) => {
              if (
                item.Nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.Email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.Apellido.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.NroDocumento.toString().includes(searchTerm) ||
                item.Edad.toString().includes(searchTerm) ||
                item.Sexo.toString().includes(searchTerm)
              ) {
                return item;
              }
              return null;
            }))}
          />
          <br />
        </div>
      </div>
    </div>
  )
}
